import { environment } from "@env/environment";
import { BaseModel } from "./base.model";

export interface ApplicationTypeMap {
  residential: string;
  business: string;
  parking: string;
  storage: string;
}

export class Building extends BaseModel {
  static APPLICATION_TYPE_INTERNAL = 'internal';
  static APPLICATION_TYPE_EXTERNAL = 'external';

  id?: string;
  instanceId?: number;

  propertyId!: string;
  applicationType!: ApplicationTypeMap;
  title?: string;
  teaser?: string;
  address?: string;
  street?: string;
  houseNumber?: string;
  postalCode?: string;
  city?: string;
  description?: string;

  coverImageId?: number;
  coverImage?: {
    id: number;
    url: string;
  };

  totalArea?: number;
  totalBusinessArea?: number;
  totalApartmentArea?: number;
  totalUnits?: number;
  totalBusinessUnits?: number;
  totalApartmentUnits?: number;
  completion?: string;
  completionText?: string;

  createdBy?: number;
  updatedBy?: number;
  createdAt?: string;
  updatedAt?: string;

  getCoverImageUrl(spec: string = '') {

    if (this.coverImage?.id) {
      let url = `${environment.apiBaseUrl}/${environment.instanceUuid}/images/${this.coverImage.id}`;
      return spec ? `${url}?spec=${spec}` : url;
    }

    if (this.coverImage?.url) {
      return this.coverImage.url;
    }

    return '/assets/img/icons/gallery.svg';
  }

}
